"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientSubMenu = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
const clientSubMenu = exports.clientSubMenu = [{
  path: '/clients/list',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/clients/list.vue'))),
  name: 'client',
  meta: {
    title: 'leadManagement.client.title',
    noCache: true,
    icon: 'building',
    roles: ['Super Admin', 'Admin', 'Sales Manager', 'Sales Coordinator', 'System Admin']
  }
}, {
  path: '/clients/add',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/clients/manage.vue'))),
  name: 'Add Client',
  props: {
    isEdit: false
  },
  meta: {
    title: 'leadManagement.client.manage',
    noCache: true,
    activeMenu: '/clients/list',
    hidden: true
  }
}, {
  path: '/clients/edit/:id(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/clients/manage.vue'))),
  name: 'Edit Client',
  props: {
    isEdit: true
  },
  meta: {
    title: 'leadManagement.client.manage',
    noCache: true,
    activeMenu: '/clients/list',
    hidden: true
  }
}];